exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".company-logo {\n  margin-top: 8px;\n}\n.schedule-home .v-responsive__content {\n  position: relative;\n}\n.schedule-home .v-responsive__content .counter-left {\n  top: 0;\n  left: 0;\n  right: unset;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border-radius: 50%;\n}\n.schedule-home .v-responsive__content .counter-right {\n  top: 0;\n  right: 0;\n  left: unset;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border-radius: 50%;\n}", ""]);

// exports
